import Cookies from 'js-cookie';

export function useCSRFToken(): string | undefined {
    const cookieName = '_auth_csrftoken';

    const cookie = Cookies.get(cookieName);

    return cookie;
}
